module.exports = __webpack_public_path__ + "img/image50.9e200e88.png";